module.exports = __webpack_public_path__ + "static/media/map-outline-02.faec0f9d.svg";